export class Contact {
  constructor() {
    const inputFile = document.querySelector('._contact__field .wpcf7-file');
    const inputFilePreview = document.querySelector('._contact__file_preview');
    const inputFileName = document.querySelector('._contact__file_preview ._contact__file_preview__file_name');
    const inputFileRemove = document.querySelector('._contact__file_preview ._contact__file_preview__file_remove');
    const responseOutput = document.querySelector('.wpcf7-response-output');
    const form = document.querySelector('._contact__form');
    const successWrapper = document.querySelector('.contact-form-success-wrapper');

    if (inputFile) {
      inputFile.addEventListener('change', () => {
        inputFilePreview.style.display = 'flex';
        inputFileName.innerHTML = inputFile.files[0].name;
      });

      inputFileRemove.addEventListener('click', () => {
        inputFile.value = '';
        inputFile.classList.remove('wpcf7-not-valid');

        inputFilePreview.style.display = 'none';
        inputFileName.innerHTML = '';
      });

      document.addEventListener('wpcf7mailsent', () => {
        inputFile.value = '';
        inputFile.classList.remove('wpcf7-not-valid');

        inputFilePreview.style.display = 'none';
        inputFileName.innerHTML = '';

        inputFileRemove.classList.remove('active');

        responseOutput.classList.add('wpcf7-response-success');

        form.style.display = 'none';
        successWrapper.style.display = 'block';

        setTimeout(() => {
          responseOutput.classList.remove('wpcf7-response-output');
        }, 300);
      });
    }
  }
}

export default new Contact;
